"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const BlocksEditor_1 = require("./BlocksEditor");
const hooks_1 = require("../../hooks");
exports.EmailCanvasEditorView = () => {
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { state: { draftEmail: { blocks }, draftEmail, conversionPanelConversions, }, } = hooks_1.useEmailCanvasContext();
    return (react_2.default.createElement(exports.EmailCanvasEditorViewInner, { conversionPanelConversions: conversionPanelConversions, blocks: blocks, dispatchCanvasAction: dispatchCanvasAction, draftEmail: draftEmail }));
};
exports.EmailCanvasEditorViewInner = ({ blocks, dispatchCanvasAction, draftEmail, conversionPanelConversions, }) => {
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "EmailCanvasEditorView", id: "emailCanvasEditorViewScrollContainer", flexColFilled: true, className: "overflow-y-auto" },
        react_2.default.createElement(react_1.OsmosysDiv, { osysName: "EmailCanvasEditorView", flexRowCenteredFilled: true },
            react_2.default.createElement(react_1.OsmosysFlexFrame.Col, { osysName: "EmailCanvasEditorView", flexFill: true, flexCol: true, maxWidth: 800, noOverflowY: true },
                react_2.default.createElement(BlocksEditor_1.EmailCanvasBlocksEditor, { blocks: blocks || [], conversionPanelConversions: conversionPanelConversions, onChange: newBlocks => {
                        dispatchCanvasAction({
                            data: {
                                draftEmail: Object.assign(Object.assign({}, draftEmail), { blocks: newBlocks }),
                            },
                            type: 'state',
                        });
                    } })))));
};
//# sourceMappingURL=index.js.map